'use strict';

var button = require('../../../../../../../../../../_virtual/button2.cjs');

(function (exports) {

	exports.ButtonAviarySizes = void 0;
	(function(ButtonAviarySizes) {
	    ButtonAviarySizes["small"] = "small";
	    ButtonAviarySizes["medium"] = "medium";
	    ButtonAviarySizes["large"] = "large";
	})(exports.ButtonAviarySizes || (exports.ButtonAviarySizes = {}));
	
} (button.__exports));
//# sourceMappingURL=button.cjs.map
